module.exports = __webpack_public_path__ + "static/media/brazil_old_pastures.62559c9f.jpg";